import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Select, Input, Button, message, Table, Switch } from 'antd';
import { State, States, Taxpayer } from 'sigt';
import { connect } from 'react-redux';
import { useWindowDimensions } from '../../../utils/hooks';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import axios from 'axios';
import { ColumnsType } from 'antd/lib/table';
import { useHistory, useLocation } from 'react-router';
import { Utils } from '../../../utils/validators';
const server = process.env.REACT_APP_SERVER_URL;

const GetAlertInfo: React.FC<GetTaxpayerInfoProps> = ({ auth, thm }) => {
  const [tipoDocumento, setTipoDocumento] = useState('V');
  const [searching, setSearching] = useState(false);
  const [taxpayers, setTaxpayers] = useState<Taxpayer[]>([]);
  const [loading, setLoading] = useState(false);

  const [query, setQuery] = useState('');

  const { width } = useWindowDimensions();
  const [form] = Form.useForm();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if((history.location.state as any)?.contribuyentes) {
      setTaxpayers((history.location.state as any)?.contribuyentes)
    }
    //eslint-disable-next-line
  }, []);

  const tipoAddon = (
    <Select defaultValue='V' value={tipoDocumento} onChange={(e) => setTipoDocumento(e)}>
      <Select.Option value='V'>V</Select.Option>
      <Select.Option value='E'>E</Select.Option>
      <Select.Option value='J'>J</Select.Option>
      <Select.Option value='G'>G</Select.Option>
      <Select.Option value='P'>P</Select.Option>
      <Select.Option value='C'>C</Select.Option>
    </Select>
  );

  const columns: ColumnsType<Taxpayer> = [
    {
      title: 'Razón Social',
      dataIndex: 'razonSocial'
    },
    {
      title: 'Documento de Identidad',
      dataIndex: 'documento',
      render: (doc, record) => <span>{record.tipoDocumento}-{doc}</span>
    },
    {
      title: 'Bloqueado',
      dataIndex: 'alerta',
      render: (alert, record) => (
        <Switch
          disabled={loading}
          checked={alert}
          onChange={() => handleSwitchAlert(record, !alert)}
        />
      ),
    }
  ];

  const handleSwitchAlert = async (contributor: Taxpayer, alert: boolean) => {
    try {
      setLoading(true);
      const response = await axios.patch(`${server}/user/alert/${contributor.id}`, {alert},{ headers: { Authorization: `Bearer ${auth?.token}` } });
      let newContributor = taxpayers.map((t) => t.id === contributor.id ? {...t, alerta: alert} : t )
      setTaxpayers(newContributor);
    } catch(e) {
      message.error(e.response?.data?.message || 'Error al buscar contribuyentes')
    } finally {
      setLoading(false);
    }
}

  const search = async () => {
    const values = await form.validateFields();
    const { razonSocial, doc } = values;
    if(razonSocial || doc) {
      try {
        setSearching(true);
        const params = doc && razonSocial ? `doc=${doc}&pref=${tipoDocumento}&name=${razonSocial}` : !razonSocial && doc ? `doc=${doc}&pref=${tipoDocumento}` : `name=${razonSocial}`;
        const response = await axios.get<{ contribuyentes: Taxpayer[] }>(`${server}/settlements/search/taxPayer?${params}`,
          { headers: { Authorization: `Bearer ${auth.token}` } });
        setTaxpayers(response.data.contribuyentes);
      } catch(e) {
        message.error(e.response?.data?.message || 'Error al buscar contribuyentes')
      } finally {
        setSearching(false);
      }
    } else {
      message.warn('Debe ingresar algún parametro para la busqueda de contribuyente')
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => fetchContributors(query), 500);
    return () => clearTimeout(timeOutId);
  }, [query]);

  const fetchContributors = async (query: string) => {
    let clean = query.trimStart()
    if(clean.length > 0) {
      setSearching(true);
      try {
        const response = await axios.get(`${server}/settlements/search/taxPayerName/${query}`, { headers: { Authorization: `Bearer ${auth.token}` } });
        setTaxpayers(response.data.contribuyentes);
      } catch (e) {
        message.error(e.response?.data?.message || 'Error al conseguir los contribuyentes');
      } finally {
        setSearching(false);
      }
    }
  };

  const fetchAllContributors = async () => {
      setSearching(true);
      try {
        const response = await axios.get(`${server}/settlements/search/allAlert`, { headers: { Authorization: `Bearer ${auth.token}` } });
        setTaxpayers(response.data.contribuyentes);
      } catch (e) {
        message.error(e.response?.data?.message || 'Error al conseguir los contribuyentes bloqueados');
      } finally {
        setSearching(false);
      }
    
  };

  return (
    <Form layout='vertical' form={form}>
      <Row gutter={24}>
        <Col xs={24} xl={7}>
          <Form.Item label='Documento de Identidad' name='doc' 
          normalize={Utils.normalize.isCNumber}
          >
            <Input placeholder='Documento de Identidad' addonBefore={tipoAddon}/>
          </Form.Item>
        </Col>
        <Col xs={24} xl={7}>
          <Form.Item label='Razón Social' name='razonSocial'>
            <Input placeholder='Razón Social' onChange={(e) => setQuery(e.target.value)}/>
          </Form.Item>
        </Col>
        <Col xl={6} xs={12}>
          <Button onClick={() => search()} style={{ marginTop: width < 1200 ? 0 : 38, marginBottom: width < 1200 ? 20 : 0 }} loading={searching} icon={<SearchOutlined />} type='primary'>Buscar</Button>
        </Col>
        <Col xl={6} xs={12}>
          <Button onClick={() => fetchAllContributors()} style={{ marginTop: width < 1200 ? 0 : 38, marginBottom: width < 1200 ? 20 : 0 }} loading={searching} icon={<SearchOutlined />} type='primary'>Mostrar todos los bloqueados</Button>
        </Col>
        <Col span={24}>
          <Table columns={columns} dataSource={taxpayers.map(t => {
            t.key = t.id;
            return t;
          })} bordered loading={searching} />
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = (state: State) => ({ auth: state.auth, thm: state.thm });

export default connect(mapStateToProps)(GetAlertInfo);

interface GetTaxpayerInfoProps {
  auth: States.Auth
  thm: States.ThemeColors
}